export function getResultPreviewInitialState() {
    return {
        uniqueId: '',
        content: '',
        isLoading: false,
        position: -1,
        resultsWithPreview: [],
    };
}
